module.exports = __webpack_public_path__ + "static/media/slide5.3d763aba.jpg";